import React from "react";
import logo from '../../assets/logo/dialog_Axiata_logo.svg.png'
import './header.css';

export default function Header(){
    return (
       <div className='header'>
           <img src={logo} alt="An Dialog Logo" className="logo"/>
           <h5>ONE NUMBER</h5>
       </div>
    )
}